import type { BoardLane } from './api';

/**
 * Board-only vocabulary. Everything else this screen labels — types,
 * priorities, the six columns — now comes from `features/labels.ts`, which is
 * re-exported below so call sites here keep one import.
 *
 * This file used to carry its own copies of all of them, with a note saying
 * they were re-declared because `requests/labels.ts` belonged to another agent
 * that week. The copies drifted: the same board column read "In progress" here
 * and "In development" on the request pane.
 */
export {
  BOARD_COLUMNS,
  COLUMN_LABELS,
  PRIORITY_LABELS,
  PRIORITY_TONES,
  TYPE_LABELS,
  TYPE_TONES,
} from '../labels';

/** Two bands: the week being worked, and what is interrupting it. */
export const LANES: readonly BoardLane[] = ['sprint', 'hotfix'];

/**
 * `sprint` is a fallback only — the band normally titles itself with the
 * started sprint's own name, which is the useful thing to read. It no longer
 * says "Locked sprint": locking and starting are separate acts now, and this
 * band follows the one that is running.
 */
export const LANE_LABELS: Readonly<Record<BoardLane, string>> = {
  sprint: 'Sprint',
  hotfix: 'Hotfixes',
};
